import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BasketballStatisticLeadersComponent } from './basketball-statistic-leaders/basketball-statistic-leaders.component';
import { StatisticLeadersComponent } from './statistic-leaders/statistic-leaders.component';
import { HockeyStatisticLeadersComponent } from './hockey-statistic-leaders/hockey-statistic-leaders.component';
import { ProgressModule, UtilsModule } from '@mtgame/ui';
import { VolleyballStatisticLeadersComponent } from './volleyball-statistic-leaders/volleyball-statistic-leaders.component';
import { FootballStatisticLeadersComponent } from './football-statistic-leaders/football-statistic-leaders.component';
import { RugbyStatisticLeadersComponent } from './rugby-statistic-leaders/rugby-statistic-leaders.component';
import { HandballStatisticLeadersComponent } from './handball-statistic-leaders/handball-statistic-leaders.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ProgressModule,
    UtilsModule,
  ],
  declarations: [
    StatisticLeadersComponent,
    BasketballStatisticLeadersComponent,
    HockeyStatisticLeadersComponent,
    VolleyballStatisticLeadersComponent,
    FootballStatisticLeadersComponent,
    HandballStatisticLeadersComponent,
    RugbyStatisticLeadersComponent,
  ],
  exports: [
    BasketballStatisticLeadersComponent,
    HockeyStatisticLeadersComponent,
    VolleyballStatisticLeadersComponent,
    FootballStatisticLeadersComponent,
    HandballStatisticLeadersComponent,
    RugbyStatisticLeadersComponent,
  ]
})
export class StatisticLeadersModule {}
